import { useTypesStore } from '../store/Types';
import { useTypesRender } from '../utils/useRender';
export var Map = props => {
  var {
    Map: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'Map');
  return null;
};
Map.displayName = 'JVR.Map';